import { Component } from '@angular/core';
import { HlAreaComponent } from './hl-area.component';
import { hatHumusForm, hatVegetationsformengruppe, trackByIndex, isM, generateMoorFBFSuggestions } from 'src/app/data-model';
import { feinbodenformFilter, hauptbodenformFilter } from 'src/app/data.service';

@Component({
    standalone: false,
    selector: '',
    templateUrl: './boden.component.html',
    styleUrls: ['./hl-area.component.css'],
    
})
export class BodenComponent extends HlAreaComponent {
  trackByIndex = trackByIndex;

	hauptbodenformFilter = hauptbodenformFilter;
  feinbodenformFilter = feinbodenformFilter;
  moorFBFRegex = "^(ah|akah|kah|ih|akih|kih|vh|akvh|kvh|ph|akph|d|akd|kd|q|akq|kq|mk|k|im|akim|kim|vm|akvm)+(Ri|Fe|EF|Ml)\\.(R|K|M|MC|Z|ZC|A|AC|D)$";
  moorFBFRegexMessage = 'Moor-FBF: Substrat + Bodenform (Ri/Fe/EF/Ml) + . + Nährkraftstufe (R/K/M/Z/A/D, ggf. +C)';
  private _moorFBFSuggestions?: string[];
  get moorFBFSuggestions(): string[] {
    if (!this._moorFBFSuggestions) {
      this._moorFBFSuggestions = isM(this.data) ? generateMoorFBFSuggestions() : [];
    }
    return this._moorFBFSuggestions;
  }
	hatHumusForm = hatHumusForm;
	hatVegetationsformengruppe = hatVegetationsformengruppe;

  addBodenformPair() {
    this.data.header.bodenform.bf.push({ trenner: '/', hbf: '', fbf: ''});
  }

  removeBodenformPair() {
    this.data.header.bodenform.bf.pop();
  }

  canAddBodenformPair() {
    const bf = this.data.header.bodenform.bf;
    const l = bf.length;
    return l > 0 && l < 3 && (bf[l-1].hbf || bf[l-1].fbf);
  }
}
